export interface GridSync<T> {
  addedList: T[];
  updatedList: T[];
  deletedIds: (number | string)[];
  changedProperties?: { [key: string]: boolean };
}
